import { Box } from "@mui/material";
import vp_logo from "../../assets/images/vp_wide.png";
import { Outlet } from "react-router-dom";

const LearnMoreLayOut = () => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "calc(95%)",
        color: "black",
        overflow: "auto",
      }}
    >
      <div
        style={{
          textAlign: "center",
          width: "calc(100%)",
          height: "120px",
          margin: "auto",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img
          src={vp_logo}
          alt="Virtues Cards Logo"
          style={{ width: "210px" }}
        />
      </div>
      <Box
        sx={{
          textAlign: "start",
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          paddingInline: "30px",
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default LearnMoreLayOut;
